import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import Port_1 from '../../../assets/images/portfolio/portfolio-image.jpg'
import Port_2 from '../../../assets/images/portfolio/portfolio-image-1.jpg'
import port_3 from '../../../assets/images/portfolio/portfolio-image-2.jpg'
import Port_next from '../../../assets/images/svg/Next.svg';
import Port_next_01 from '../../../assets/images/svg/Next-2.svg';

const Portfilo = () => {
    const portSlider = {
        speed: 1500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: false,
        arrows: true,
        prevArrow: (
            <button type="button" className="slick-prev">
                <img src={Port_next} alt="Previous" />
            </button>
        ),
        nextArrow: (
            <button type="button" className="slick-next">
                <img src={Port_next_01} alt="Next" />
            </button>
        ),
    };

    return (
        <>
            <div className="portfolio-section-two">
                <div className="container-fluid p-0">
                    <Slider className="portfolio-slider-two" {...portSlider}>
                        <div className="portfolio-item-two">
                            <div className="portfolio-image-two">
                                <img
                                    src={Port_1}
                                    alt="portfolio-image"
                                />
                            </div>
                            <div className="portfolio-details-two">
                                <span className="sub-title">POrtfolio</span>
                                <Link to="/Details" className="portfolio-btn">
                                    <svg
                                        width={20}
                                        height={20}
                                        viewBox="0 0 13 13"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.95508 11.2104L12.1348 1.03075"
                                            stroke="white"
                                            strokeWidth="1.18984"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M1.03125 1.03061H12.1364V12.1357"
                                            stroke="white"
                                            strokeWidth="1.18984"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                                <p>
                                    by <span>Brandon Maxwell</span>
                                </p>
                                <h4>Minimal Design</h4>
                                <span>Marketing</span>
                            </div>
                        </div>
                        <div className="portfolio-item-two">
                            <div className="portfolio-image-two">
                                <img
                                    src={Port_2}
                                    alt="portfolio-image"
                                />
                            </div>
                            <div className="portfolio-details-two">
                                <span className="sub-title">POrtfolio</span>
                                <Link to="/Details" className="portfolio-btn">
                                    <svg
                                        width={20}
                                        height={20}
                                        viewBox="0 0 13 13"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.95508 11.2104L12.1348 1.03075"
                                            stroke="white"
                                            strokeWidth="1.18984"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M1.03125 1.03061H12.1364V12.1357"
                                            stroke="white"
                                            strokeWidth="1.18984"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                                <p>
                                    by <span>Steve Jobs</span>
                                </p>
                                <h4>Innovator</h4>
                                <span>Business Strategy</span>
                            </div>
                        </div>
                        <div className="portfolio-item-two">
                            <div className="portfolio-image-two">
                                <img
                                    src={port_3}
                                    alt="portfolio-image"
                                />
                            </div>
                            <div className="portfolio-details-two">
                                <span className="sub-title">POrtfolio</span>
                                <Link to="/Details" className="portfolio-btn">
                                    <svg
                                        width={20}
                                        height={20}
                                        viewBox="0 0 13 13"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.95508 11.2104L12.1348 1.03075"
                                            stroke="white"
                                            strokeWidth="1.18984"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M1.03125 1.03061H12.1364V12.1357"
                                            stroke="white"
                                            strokeWidth="1.18984"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                                <p>
                                    by <span>Seth Godin</span>
                                </p>
                                <h4>Marketing Expert</h4>
                                <span>Brand Strategy</span>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>

        </>
    )
}

export default Portfilo
